/**
 * Created with Mei Zhiwei on 2017-11-28 16:16:40.
 * Description: 工具类
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: fanzhijie
 * @Last Modified time: 2021-04-25 17:55:12
 */
import _ from 'lodash';
import moment from 'moment';

export function extract(o) {
  let result = [];
  _.forOwn(o, function (value, key) {
    result.push({
      id: parseInt(key),
      description: value
    });
  });
  return result.sort((s, t) => s.id - t.id);
}

export function formatTimeYMD(t) {
  return t ? moment(t).format('YYYY-MM-DD') : '';
}

export function formatTimeYMDHMS(t) {
  return t ? moment(t).format('YYYY-MM-DD HH:mm:ss') : '';
}

export function formatTimeHMS(t) {
  return t ? moment(t).format('HH:mm:ss') : '';
}

export function formatTimeMDHMSS(t) {
  return t ? moment(t).format('MM-DD HH:mm:ss.SSS') : '';
}

export function isArray(input) {
  return (
    input instanceof Array ||
    Object.prototype.toString.call(input) === '[object Array]'
  );
}
export function isObject(input) {
  // IE8 will treat undefined and null as object if it wasn't for
  // input != null
  return (
    input != null && Object.prototype.toString.call(input) === '[object Object]'
  );
}

export function isNumber(input) {
  return (
    typeof input === 'number' ||
    Object.prototype.toString.call(input) === '[object Number]'
  );
}

export function isString(input) {
  return (
    typeof input === 'string' ||
    Object.prototype.toString.call(input) === '[object String]'
  );
}

export function isDate(input) {
  return (
    input instanceof Date ||
    Object.prototype.toString.call(input) === '[object Date]'
  );
}

export function isFunction(input) {
  return (
    input instanceof Function ||
    Object.prototype.toString.call(input) === '[object Function]'
  );
}

/**
 * 逗号分隔字符串转int数组
 * @param 逗号分隔字符串 string
 */
export function stringToIntArray(string) {
  if (string) {
    let strArr = string.split(',');
    let intArr = [];
    strArr.forEach(str => {
      intArr.push(parseInt(str));
    });
    return intArr;
  }
  return [];
}

/**
 * 深拷贝对象
 *
 * 注意：无法拷贝对象中的函数
 * @param {源对象} source
 */
export function copyObject(source) {
  return JSON.parse(JSON.stringify(source));
}

export function getDescription(descs, id) {
  let desc = '';
  descs.forEach(c => {
    if (parseInt(c.id) === parseInt(id)) {
      desc = c.description;
    }
  });
  return desc || '未知';
}

export function getBizUni(path) {
  let res = ''
  if (path) {
    let pathStr = String(path);
    let pathArr = pathStr.split('/');
    pathArr.forEach(ele => {
      if (_.startsWith(ele, 'BizUni_')) {
        res = ele;
      }
    });
  }
  return res;
}



// WEBPACK FOOTER //
// ./src/lib/utils.js